<template>
  <div class="view-box">
    <!-- 加载状态 -->
    <div
      style="
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 999999;
        display: flex;
        justify-content: center;
        align-items: center;
      "
      v-show="loading"
    >
      <van-loading color="#1989fa" />
    </div>
    <div class="header">
      <span>居住地址</span>
      <div class="back" @click="back">
        <van-icon name="arrow-left" size="24" />
        <span>返回</span>
      </div>
    </div>
    <!-- 搜索 -->
    <van-search v-model="searchValue" placeholder="搜索" />
    <!-- 搜索列表 -->
    <div class="list-box">
      <div
        class="item"
        v-for="(item, index) in communityOptins"
        :key="index"
        @click="checkCommunity(item)"
      >
        <span class="name">{{ item.name }}</span>
        <span class="area">{{ item.addr }}</span>
      </div>
    </div>
    <!-- 确认 -->
    <div class="submit-box">
      <van-button type="info" @click="checkArea" class="view-box"
        >确认</van-button
      >
    </div>
  </div>
</template>

<script>
import { getAreaAPI } from "@/server/api";
import { Icon, Search, Notify, Button, Loading } from "vant";
export default {
  name: "selectCommunity",
  components: {
    [Icon.name]: Icon,
    [Search.name]: Search,
    [Notify.name]: Notify,
    [Button.name]: Button,
    [Loading.name]: Loading,
  },
  data() {
    return {
      loading: false, // 加载状态
      searchValue: "", // 搜索内容
      originalData: [], // 原始社区数据
      searchData: [], // 搜索数据
      communityOptins: [], // 社区列表
      mapCommunityOptins: [], // 地图搜索的社区列表
      center: {
        lng: "120.27160799999997",
        lat: "29.722377997300015",
      }, // 中心经纬度
    };
  },
  watch: {
    searchValue(newData) {
      if (newData.length >= 2) {
        this.onSearch();
      } else {
        this.searchData = [];
        this.communityOptins = [];
      }
    },
  },
  deactivated() {
    this.searchValue = "";
    this.searchData = [];
    this.communityOptins = [];
  },
  mounted() {
    // 获取用户当前位置
    let geolocation = new window.BMapGL.Geolocation();
    let _this = this;
    geolocation.getCurrentPosition(function (r) {
      if (this.getStatus() === 0) {
        _this.center = {
          lng: r.point.lng,
          lat: r.point.lat,
        };
      }
    });
  },
  methods: {
    // 搜索
    onSearch() {
      if (this.searchValue.length > 0) {
        this.loading = true;
        let params = {
          area: this.searchValue,
          point: `${this.center.lat},${this.center.lng}`,
        };
        getAreaAPI(params)
          .then((res) => {
            this.loading = false;
            const { code, data, msg } = res.data;
            if (code === 200) {
              this.communityOptins = data;
            } else {
              Notify({ type: "warning", message: msg });
            }
          })
          .catch((err) => {
            this.loading = false;
            Notify({ type: "danger", message: err.message });
          });
      }
    },
    // 确认地址
    checkCommunity(item) {
      this.$store.commit("setCheckHousing", item);
      this.back();
    },
    // 手动确认地址
    checkArea() {
      if (this.searchValue.length < 1) {
        Notify({ type: "warning", message: "请输入地址" });
      } else {
        this.$store.commit("setCheckHousing", {
          name: this.searchValue,
        });
        this.back();
      }
    },
    // 返回上一页
    back() {
      if (this.$route.query.addRelation) {
        this.$router.push({
          path: "/registrationInfo",
          query: {
            addRelation: 1,
            areaSelect: 1,
          },
        });
      } else {
        this.$router.push({
          path: "/registrationInfo",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  height: 5rem;
  line-height: 5rem;
  font-size: 1.6rem;
  color: #333;
  background: #fff;
  text-align: center;
  position: relative;
  .back {
    position: absolute;
    top: 0;
    left: 0.8rem;
    display: flex;
    align-items: center;
  }
}
.list-box {
  width: 100%;
  margin-top: 1.2rem;
  padding: 0 1.6rem;
  background: #fff;
  .item {
    width: 100%;
    height: 7rem;
    padding: 1rem 0;
    border-bottom: 1px solid #f5f5f5;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .name {
      font-size: 1.5rem;
      color: #333;
    }
    .area {
      font-size: 1.4rem;
      color: #777;
    }
  }
}
.submit-box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0.8rem 1.6rem;
  background: #fff;
  box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: space-between;
}
.map-box {
  width: 100%;
  padding-bottom: 100%;
  height: 0;
  background: #ccc;
}
</style>
